import * as yup from 'yup';

function requiredIfCondition<T extends yup.AnySchema>(
  schemaType: T,
  fields: string[],
  condition: (...values: any[]) => boolean,
  message: string,
  disableRequired = true,
): T {
  if (disableRequired) return schemaType.notRequired();

  return schemaType.when(fields, {
    is: (...fieldValues: any[]) => condition(...fieldValues),
    then: (schema: T) => schema.required(message),
    otherwise: (schema: T) => schema.notRequired(),
  });
}

const propertyDetailSchema = yup.object().shape({
  propertyPurpose: yup.string(),
  propertyLocation: yup.string().required('Property location is required'),
  propertyAddress: yup.string().required('Property address is required'),
  propertyCountry: yup.string(),
  propertyOwner: yup.string(),
  propertyUse: yup.string(),
  refinanceInterestType: yup.string(),
  propertyAmountRequired: yup.string(),
  propertyAmountPurpose: yup.string(),
  propertyValue: yup
    .number()
    .typeError('Property value must be a number')
    .required('Property value is required')
    .positive('Property value must be a positive number'),
  isMortgageOnProperty: yup.boolean().required('Mortgage status is required'),
  mortgageLoanLimit: requiredIfCondition(
    yup
      .number()
      .typeError('Mortgage loan limit must be a number')
      .positive('Mortgage loan limit must be a positive number'),
    ['isMortgageOnProperty', 'propertyLocation'],
    (isMortgageOnProperty, propertyLocation) =>
      isMortgageOnProperty && propertyLocation === 'australian',
    'Mortgage loan limit is required',
  ),
  propertyRent: yup.number().typeError('Property rent must be a number'),
  propertyRentFrequency: yup.string(),
  // repaymentSum: requiredIfCondition(
  //   yup
  //     .number()
  //     .typeError('Repayment sum must be a number')
  //     .positive('Repayment sum must be a positive number'),
  //   ['isMortgageOnProperty', 'propertyLocation'],
  //   (isMortgageOnProperty, propertyLocation) =>
  //     isMortgageOnProperty && propertyLocation === 'australian',
  //   'Repayment sum is overseas',
  // ),
  repaymentSum: yup.number().typeError('Repayment sum must be a number'),
  // mortgageLender: requiredIfCondition(
  //   yup.string().required('Mortgage lender is required'),
  //   ['isMortgageOnProperty'],
  //   (isMortgageOnProperty) => isMortgageOnProperty,
  //   'Mortgage lender is required',
  // ),
  mortgageLender: yup.string().typeError('Mortgage lender is required'),
  mortgageLoanTerm: requiredIfCondition(
    yup
      .number()
      .typeError('Mortgage loan term must be a number')
      .positive('Mortgage loan term must be a positive number'),
    ['isMortgageOnProperty'],
    (isMortgageOnProperty) => isMortgageOnProperty,
    'Mortgage loan term is required',
  ),
  mortgageInterest: requiredIfCondition(
    yup
      .number()
      .max(100, 'Interest rate cannot exceed 100')
      .typeError('Interest rate must be a number')
      .positive('Interest rate must be a positive number'),
    ['isMortgageOnProperty'],
    (isMortgageOnProperty) => isMortgageOnProperty,
    'Interest rate is required',
  ),
  mortgageInterestType: requiredIfCondition(
    yup.string().required('Interest type is required'),
    ['isMortgageOnProperty'],
    (isMortgageOnProperty) => isMortgageOnProperty,
    'Interest type is required',
  ),
  currency: yup.string(),
  propertyOwnership: yup
    .bool()
    .typeError('Ownership interest must be a Boolean'),
  propertyInterest: yup
    .bool()
    .typeError('Ownership interest must be a Boolean'),

  loanOnFixedRate: yup.boolean(),
});

export default propertyDetailSchema;
